export const COORDINATES_DENMARK = Object.freeze({
    latitude: 56.09021,
    longitude: 8.24463,
});
